import { type TabType } from '@repo/utils';

export const getFormTabs = `
  query getFormTabs($formId: ID!) {
    formTabs(formId: $formId) {
      id
      name
      sequenceNumber
    }
  }
`;

export type FormTabsTabType = Pick<TabType, 'id' | 'name' | 'sequenceNumber'>;

export interface GetFormTabsQuery {
  formTabs: FormTabsTabType[];
}
